// extracted by mini-css-extract-plugin
export default {"Toggle":"SwitchToggle_Toggle__847KU","Active":"SwitchToggle_Active__0pWng","Slider":"SwitchToggle_Slider__lbmxP"};